module.exports = "pegasus/assets/arrow-up.png";